import { Navigate, RouteObject } from "react-router-dom";
import ReminderPop from "./reminderPop"

const authsRoute: RouteObject = {
  path: 'ith-reminder',
  element: (<ReminderPop />),
};

export default authsRoute;
